import React, {Component, Fragment} from 'react';
import DeleteContact from './DeleteContact';
import BootstrapTable from 'react-bootstrap-table-next';
import {NavLink} from 'react-router-dom';
import {ButtonGroup} from 'reactstrap';

function contactActions(cell, row) {
    return (
        <ButtonGroup>
            <NavLink to={`/contact/${row.id}`} className='btn btn-primary'>
                <i className='fa fa-edit'> </i>
            </NavLink>
            <DeleteContact contact={row}/>
        </ButtonGroup>
    )
}

function emailCell(cell, row) {
    return (
        <a href={`mailto:${row.email}`}>{row.email}</a>
    )
}

const contactListColumns = [
    {
        dataField: 'type',
        text: 'Funktion'
    },
    {
        dataField: 'title',
        text: 'Anrede'
    },
    {
        dataField: 'name',
        text: 'Name'
    },
    {
        dataField: 'email',
        text: 'E-Mail',
        headerStyle: {
            width: '15em'
        },
        formatter: (cell, row) => emailCell(cell, row)
    },
    {
        dataField: 'phone',
        text: 'Festnetz'
    },
    {
        dataField: 'mobile',
        text: 'Mobil'
    },
    {
        isDummyField: true,
        dataField: 'id',
        text: '',
        formatter: (cell, row) => contactActions(cell, row)
    },
];

export default class ContactTable extends Component {
    render() {
        const addButton = this.props.addButton;
        const customerId = this.props.customer;
        const contacts = this.props.contacts;
        const ContactRow =
            {
                renderer: row => (
                    <p>
                        {row.note}
                    </p>
                ),
                expanded: contacts
            };
        return (
            <Fragment>
                {
                    addButton &&
                    <NavLink
                        className='btn btn-primary'
                        to={`/customer/${customerId}/contact/new`}
                    >
                        Ansprechpartner hinzufügen
                    </NavLink>
                }
                <BootstrapTable
                    classes='mt-3'
                    keyField='id'
                    data={contacts}
                    columns={contactListColumns}
                    bootstrap4
                    condensed
                    responsive
                    expandRow={ContactRow}
                />
            </Fragment>
        )
    }
}
